import bg1 from '../../../Assets/001.png';
import bg2 from '../../../Assets/01.jpg';
import bg3 from '../../../Assets/03.jpg';
import bg4 from '../../../Assets/04.jpg';
import bg5 from '../../../Assets/C5.jpg';

import cg1 from '../../../Assets/C1.jpg';
import cg2 from '../../../Assets/C2.jpg';
import cg3 from '../../../Assets/C3.jpg';
import cg4 from '../../../Assets/C4.jpg';
import cg5 from '../../../Assets/C5.jpg';

export const SliderData = [
    {
        image: cg1,
        title: 'Prime Asset Flow',
        tag: 'WE ARE THE',
        content: 'Prime Asset Flow - The best way to passive income, we are creating a business opportunity for investors who wishes to maximize digital currency and earn passively with little or no effort, and also aid our investors make their livestyle worth living without any left-out debt.'
    },
    {
        image: cg2,
        title: 'Prime Asset Flow',
        tag: 'WE ARE TRUSTED',
        content: `Prime Asset Flow - We are trusted and reliable. Prime Asset Flow is available 24/7 to serve you. Our clients satisfaction is our outmost concern and responsibility. Don't wait! Open an account with us today.`
    },
    {
        image: cg3,
        title: 'Prime Asset Flow',
        tag: 'WE ALWAYS DELIVER',
        content: `Prime Asset Flow - Invest in cryptocurrency and earn massive daily profits on money of the future today as fiat currency is fading.`
    },
    {
        image: cg4,
        title: 'Prime Asset Flow',
        tag: "WE PUT INVESTORS FIRST",
        content: `Join us today start earning from our VIP Channel, Investment Packages and Account Management Services. Enjoy 24/7 Support Service.`
    },
    {
        image: cg5,
        title: 'Prime Asset Flow',
        tag: 'WE ARE GENUINE',
        content: `We trade with bots and master class strategy on MetaTradet 4, MetaTrader 5 & IQ Option Binary Tradng Platform to pursue consistent results in the market.`
    }
]